import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'

class CommonNotificationSettingChange extends Component {
  constructor (props) {
    super(props)
    this.state = {emailNotification: '', isMember: ''}
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  componentWillMount () {
    AWSAPI.getUserAttributes(this.userRole, (err, result) => {
      if (err) {
        // console.log(err) //デバッグ時以外はコメントアウト
        return
      }
      console.log(result)
      const emailNotificationAttr = result.filter((e) => e.Name === 'custom:emailNotification')[0];
      const emailNotification = emailNotificationAttr ? emailNotificationAttr.Value : false;

      this.setState({
        emailNotification: emailNotification
      });
    })
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onChangeNotification (e) {
    e.preventDefault()
    AWSAPI.updateAttributes(
      this.userRole,
      [{
        Name: 'custom:emailNotification',
        Value: this.state.emailNotification
      }],
      (err, result) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
          return
        }
        Window.alert('通知受信可否設定を変更しました。', () => {
          this.props.history.push('/' + this.userRoleUrl + '/personal_setting_home/')
          Window.closeDialog()
        })
      }
    )
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/' + this.userRoleUrl + '/personal_setting_home/')
        break
      default:
        break
    }
  }
  renderNotificationSetting () {
    return (
      <div>
        <form className='form-horizontal' method='post'>
          <div className='container'>
            <div className='alert alert-block alert-info'>
              <p>必要な情報を選択して最後に「通知受信可否設定を変更する」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
            </div>
            <fieldset>
              <legend>通知受信可否設定の変更</legend><br />
              <div className='control-group'>
                <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
                <div className='controls kw-radio'>
                  <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={this.state.emailNotification === 'true' || this.state.emailNotification === 'True'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
                  <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={this.state.emailNotification === 'false' || this.state.emailNotification === 'False'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
                </div>
              </div>
            </fieldset>
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary btn-l' name='action' value='CONFIRM' onClick={e => this.onChangeNotification(e)}>通知受信可否設定を変更する</button>
            </footer>
          </div>
        </form>
      </div>
    )
  }
  render () {
    const notificationSetting = this.renderNotificationSetting()
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>通知受信可否設定の変更<br /><small>こちらでお知らせメールの通知受信可否が設定できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          {notificationSetting}
        </section>
      </div>
    )
  }
}

export default CommonNotificationSettingChange



// WEBPACK FOOTER //
// ./src/common/pages/secure/NotificationSettingChange.js